import {createSlice} from "@reduxjs/toolkit";
import {ParentWebviewType, WebformAppMode} from "config/appModes";

interface AppModeState {
    app_mode: WebformAppMode;
    parent_type: ParentWebviewType;
}

export const initialState: AppModeState = {
    app_mode: WebformAppMode.WEBFORM,
    parent_type: ParentWebviewType.WEB,
};

export const slice = createSlice({
    name: "webform/appMode",
    initialState,
    reducers: {},
});

export default slice.reducer;
